import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import { DeleteDispatchIssueInput, DeleteDispatchIssueBulkResponse, MutationDeleteDispatchIssueBulkArgs } from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { DeleteDispatchIssue } from '@/features/IssueHistory/api/queries/DeleteDispatchIssue';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteDispatchIssueInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteDispatchIssueBulkResponse>;
}

// DeleteDispatchIssue Service
export const { deleteDispatchIssue, useDeleteDispatchIssue } = ((): {
  deleteDispatchIssue: ServiceMethod;
  useDeleteDispatchIssue: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteDispatchIssue).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: DeleteDispatchIssueInput[], options?: ConnectionOptions): Promise<DeleteDispatchIssueBulkResponse> => {
        const args: MutationDeleteDispatchIssueBulkArgs = {
          input: {
            search: payload,
          },
        };
        const opts = { merge: options?.merge ? 'deleteDispatchIssueBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteDispatchIssueBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteDispatchIssue: fetch,
    useDeleteDispatchIssue: useService,
  };
})();
